#import "./TrainingModuleAdminFields.graphql"

mutation SetTrainingQuestionActive($questionId: ID!, $active: Boolean!) {
  setTrainingQuestionActive(
    input: { questionId: $questionId, active: $active }
  ) {
    trainingModule {
      ...TrainingModuleAdminFields
    }
  }
}
